module.exports = __webpack_public_path__ + "static/media/booking_data_format.a197ea88.xlsx";